<template>
  <div class="numeric-keyboard flex">
    <Btn text="1" center @click.native.stop="setValue(...arguments, 1)"/>
    <Btn text="2" center @click.native.stop="setValue(...arguments, 2)"/>
    <Btn text="3" center @click.native="setValue(...arguments, 3)"/>
    <Btn text="4" center @click.native="setValue(...arguments, 4)"/>
    <Btn text="5" center @click.native="setValue(...arguments, 5)"/>
    <Btn text="6" center @click.native="setValue(...arguments, 6)"/>
    <Btn text="7" center @click.native="setValue(...arguments, 7)"/>
    <Btn text="8" center @click.native="setValue(...arguments, 8)"/>
    <Btn text="9" center @click.native="setValue(...arguments, 9)"/>
    <Btn icon="back" center @click.native="setValue(...arguments, -1)"/>
    <Btn text="0" center @click.native="setValue(...arguments, 0)"/>
    <Btn icon="ok" center @click.native="setValue(...arguments, -2)"/>
<!--    <SimpleKeyboard-->
<!--      :input="input"/>-->
  </div>
</template>

<script>
// import SimpleKeyboard from '@/components/Basic/KeyboardBasic'
// import Btn from '@/components/Basic/Btn'
import Btn from '@/components/basic/Btn'

export default {
  name: 'NumericKeyboard',
  components: {
    Btn
    // SimpleKeyboard
  },
  data: () => ({
    input: ''
  }),
  methods: {
    setValue (ev, value) {
      ev.stopPropagation()
      ev.preventDefault()
      console.log('click event', ev)
      this.$emit('digit', value)
    }
  }
}
</script>

<style lang="scss">
$keyboard-size: 12.75rem;
$button-size: 4rem;

.numeric-keyboard {
  width: $keyboard-size;
  height: $keyboard-size;
  position: absolute;
  background: #FFFFFF;
  border: 2px solid $magenta;
  bottom: calc(#{$size-grid / 2} + 1px);
  flex-wrap: wrap;
  left: calc(50% - 6.4rem);
  justify-content: space-around;
  z-index: 100;

  >.button {
    /*width: $button-size !important;*/
    width: 33.3%;
    height: calc(#{$button-size} - 14px);
    font-size: 1.5rem;
    font-family: AvenirHeavy;
    svg {
      transform: scale(2) !important;
      pointer-events: none !important;
    }

    &:hover {
      background-color: $cyan;
      color: $white;

      svg {
        fill: $white !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/KeyboardNumeric.vue